import { AxiosInstance } from 'axios';
import {
  SleepingRemarkRepository,
} from '@/model/repository/manager/dailyCheck/sleeping/remark/repository';

export default (axios: AxiosInstance) =>
  (resource: string): SleepingRemarkRepository => ({
    async get({ memberId, date }) {
      const formattedDate = adaptDate(date);
      const {status, data} = await axios.get<Response>(`${resource}/sleeping/members/${memberId}/remarks/${formattedDate}`);
      if (status !== 200) {
        throw new Error(`Failed to fetch sleeping remark: ${status}`);
      }
      return adaptResponse(data);
    },
    async put({memberId, date, remark}) {
      const formattedDate = adaptDate(date);
      const {status, data} = await axios.put<Response>(`${resource}/sleeping/members/${memberId}/remarks/${formattedDate}`, {
        remark: remark === undefined ? null : remark,
      }, {
        validateStatus: () => true, // Always resolve promise to handle errors in catch block
      });
      if (status > 201) {
        throw { status };
      }
      return adaptResponse(data);
    }
  });

  type Response = {remark: string | null}

  const adaptDate = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  const adaptResponse = ({remark}: Response) => ({
    remark: remark ?? undefined,
  });